export const PERMISSION_ROLE_OPTIONS = [
  { value: 'STAFF', label: 'Staff' },
  { value: 'MANAGER', label: 'Manager' },
];

export const OWNER_PERMISSION_OPTION = { value: 'OWNER', label: 'Owner' };

export const TEAM_TYPE_OPTIONS = [
  { value: 'INTERNAL', label: 'Interno' },
];

export const COMPANY_ROLE_OPTIONS = [
  'Amministrazione',
  'Commerciale',
  'Designer',
  'Developer',
  'Operativo',
  'Consulente',
  'Collaboratore',
  'Altro',
];

export const workspaceUsersFilterConfig = {
  search: {
    key: 'query',
    placeholder: 'Cerca utenti...',
  },
  groups: [
    {
      key: 'teamType',
      label: 'Team',
      selection: 'multi',
      options: TEAM_TYPE_OPTIONS,
    },
    {
      key: 'permissionRole',
      label: 'Permessi',
      selection: 'multi',
      options: [
        ...PERMISSION_ROLE_OPTIONS,
        OWNER_PERMISSION_OPTION,
      ],
    },
    {
      key: 'status',
      label: 'Stato',
      selection: 'multi',
      options: [
        { value: 'ACTIVE', label: 'Attivo' },
        { value: 'INACTIVE', label: 'Inattivo' },
      ],
    },
    {
      key: 'inviteStatus',
      label: 'Invito',
      selection: 'multi',
      options: [
        { value: 'ACCEPTED', label: 'Accettato' },
        { value: 'PENDING', label: 'In attesa' },
        { value: 'EXPIRED', label: 'Scaduto' },
      ],
    },
  ],
};

export function getPermissionRoleLabel(role) {
  const normalized = (role || '').toUpperCase();
  if (normalized === 'OWNER') {
    return 'Owner';
  }
  return PERMISSION_ROLE_OPTIONS.find((option) => option.value === normalized)?.label || role || 'N/D';
}

export function getTeamTypeLabel(teamType) {
  return TEAM_TYPE_OPTIONS.find((option) => option.value === teamType)?.label || 'Interno';
}

export function getInviteStatusLabel(user) {
  const status = user.inviteStatus || (user.active ? 'ACCEPTED' : 'PENDING');
  if (status === 'ACCEPTED') {
    return 'Accettato';
  }
  if (status === 'EXPIRED') {
    return 'Scaduto';
  }
  if (status === 'PENDING' || status === 'INVITED') {
    return 'In attesa';
  }
  return status || 'N/D';
}

export function getInviteStatusTone(user) {
  const status = user.inviteStatus || (user.active ? 'ACCEPTED' : 'PENDING');
  if (status === 'ACCEPTED') {
    return 'completed';
  }
  if (status === 'EXPIRED') {
    return 'review';
  }
  return 'approved';
}

export function getUserStatusLabel(user) {
  return user.active ? 'Attivo' : 'Inattivo';
}

export function getUserStatusTone(user) {
  return user.active ? 'signed' : 'approved';
}
